// Default criteria for the nightly discovery engine.
// Persisted per-install in the cost_library table (scope = criteria:default).
// This module provides the seed values used when no custom criteria exist yet.

import { suburbFromPostcode } from './sa-postcodes.js';

export const DEFAULT_CRITERIA = Object.freeze({
  suburbs: [
    { name: "O'Halloran Hill", postcode: '5158' },
    { name: 'Morphett Vale',   postcode: '5162' },
    { name: 'Christies Beach', postcode: '5165' },
    { name: 'Seaford',         postcode: '5169' },
    { name: 'Reynella',        postcode: '5161' },
    { name: 'Hallett Cove',    postcode: '5158' },
    { name: 'Trott Park',      postcode: '5158' },
    { name: 'Sheidow Park',    postcode: '5158' },
    { name: 'Noarlunga Downs', postcode: '5168' },
    { name: 'Old Noarlunga',   postcode: '5168' },
  ],
  land_min_m2: 500,
  land_max_m2: 1500,
  price_max: 900_000,
  property_types: ['house'],
  target_dwellings: 3,
  min_verdict: 'unlikely',
});

// Merge saved criteria over defaults and coerce every suburb entry to
// { name, postcode } with the name resolved from the postcode when
// possible. Handles legacy shapes still sitting in localStorage:
// plain-string postcodes, postcode-only rows, postcodes typed into the
// name field.
export function normalizeCriteria(saved = {}) {
  const c = { ...DEFAULT_CRITERIA, ...saved };
  c.suburbs = (c.suburbs ?? []).map((entry) => {
    let name = '';
    let postcode = '';
    if (typeof entry === 'string') {
      if (/^\d{4}$/.test(entry.trim())) postcode = entry.trim();
      else name = entry.trim();
    } else if (entry && typeof entry === 'object') {
      name = (entry.name ?? '').trim();
      postcode = String(entry.postcode ?? '').trim();
      if (/^\d{4}$/.test(name)) {
        postcode = postcode || name;
        name = '';
      }
    }
    if (!name) name = suburbFromPostcode(postcode) ?? '';
    return { name, postcode };
  });
  return c;
}
